export default "__VITE_ASSET__49fa8fbe__"